<ng-container *ngIf="notification">
    <ng-container *ngIf="timezone$ | async as timezone; else mstTimeTemplate">
        <ds-notification
            theme="info"
            header="New Service Request"
            [content]="
                'Service request created by ' +
                notification.customerName +
                ' at ' +
                (notification.createdOn | convertDate: timezone | date: HOUR_MINUTE_FORMAT) +
                ' ' +
                (timezone.shortName | timezoneAbbreviation)
            "
            (viewClick)="onViewServiceRequest()"
            (dismissClick)="closeNotification()"
        ></ds-notification>
    </ng-container>

    <ng-template #mstTimeTemplate>
        <ds-notification
            theme="info"
            header="New Service Request"
            [content]="
                'Service request created by ' +
                notification.customerName +
                ' at ' +
                (notification.createdOn | date: HOUR_MINUTE_FORMAT) +
                ' MST'
            "
            (viewClick)="onViewServiceRequest()"
            (dismissClick)="closeNotification()"
        ></ds-notification>
    </ng-template>
</ng-container>
